import React from 'react';
import { AppBar, Typography, Button, Toolbar, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();

  return (
    <AppBar position="static" component="footer" sx={{ mt: 'auto' }}>
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        {/* Empty left section to center the navigation */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {/* Placeholder for left spacing */}
        </Box>
        
        {/* Center section - Legal links */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Button 
            color="inherit"
            component={RouterLink}
            to="/about"
          >
            {t('aboutUsTitle')}
          </Button>
          <Button 
            color="inherit"
            component={RouterLink}
            to="/contact"
          >
            {t('contactTitle')}
          </Button>
          <Button 
            color="inherit"
            component={RouterLink}
            to="/privacy"
          >
            {t('privacyPolicyTitle')}
          </Button>
          <Button 
            color="inherit"
            component={RouterLink}
            to="/terms"
          >
            {t('termsOfServiceTitle')}
          </Button>
        </Box>
        
        {/* Right section - Copyright */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography 
            variant="body2" 
            color="inherit"
            sx={{ opacity: 0.7, fontSize: '0.75rem' }}
          >
            © 2025 StandStrong
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Footer;
